import useAnalytics from "./useAnalytics.mjs";
import useIntersectionObserver from "../composables/useIntersectionObserver.mjs";
export default function useSectionAnalytics(target, data, options) {
  const { threshold = 0.1, mode = "section", rootMargin = "0px 0px -25% 0px" } = options ?? {};
  const { trackViewSection, trackSelectItem: trackSelectItemAnalytics } = useAnalytics();
  const dataItems = data.items?.length ? data.items : [];
  useIntersectionObserver(target, threshold, () => {
    let items = [];
    switch (mode) {
      case "section":
        items = dataItems;
        break;
      case "carousel":
        items = dataItems?.length ? dataItems[0].links?.length ? dataItems[0].links : [dataItems[0]] : [];
        break;
    }
    trackViewSection(options?.sectionName ?? "", data.placement, items);
  }, { rootMargin });
  const trackViewActiveItem = (index) => {
    if (typeof index !== "number" || index === 0 || !dataItems[index]) {
      return;
    }
    const items = dataItems[index].links?.length ? dataItems[index].links : [dataItems[index]];
    trackViewSection(options?.sectionName ?? "", data.placement, items);
  };
  const trackSelectItem = (arg) => {
    let itemsToTrack = [];
    if (typeof arg === "number") {
      if (dataItems[arg]) {
        itemsToTrack = [dataItems[arg]];
      }
    } else if (arg && typeof arg === "object") {
      itemsToTrack = [arg];
    } else {
      itemsToTrack = dataItems;
    }
    if (itemsToTrack.length > 0) {
      trackSelectItemAnalytics(options?.sectionName ?? "", data.placement, itemsToTrack);
    }
  };
  return {
    trackSelectItem,
    trackViewActiveItem
  };
}
